module.exports = __webpack_public_path__ + "static/media/frag02.fedda6cb.glsl";